module.exports = __webpack_public_path__ + "static/media/computer-speaker.2cfa8bd1.svg";